// Constants
import { cardShadow } from "Constants/ColourConstants";
import { BUTTON_BORDER_RADIUS } from "Constants/theme";

export const styles = {
  page: {
    minHeight: "100svh",
    alignItems: "center",
  },
  content: {
    width: "min(30rem, calc(100vw - 2rem))",
    minWidth: "325px",
  },
  card: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: BUTTON_BORDER_RADIUS,
    boxShadow: cardShadow,
    py: { xs: 3.5, sm: 4 },
    px: { xs: 3.5, sm: 5 },
  },
  forgotPasswordButton: {
    width: "fit-content",
    minHeight: 0,
    px: 1.75,
    py: 0,
    mr: -1.75,
    color: "secondary.main",
    fontWeight: "bold",
  },
  footerLink: {
    color: "inherit",
    fontWeight: 700,
    textDecoration: "underline",
  },
  authFormFadeIn: {
    animation: "authFormFadeIn 400ms ease-out",
    "@keyframes authFormFadeIn": {
      from: {
        opacity: 0,
        transform: "translateY(2px)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0)",
      },
    },
  },
};
